<section class="co-header">
  <div class="c-wrapper">
    <h1 class="co-header__title u-text-center">{{ isCasual() ? '電話' : '無料' }}カウンセリング予約</h1>
    <ol class="co-header__process u-text-center">
      <li class="co-header__item" [class.current]="mode() === 'step1'"><div>1</div><div>日時選択</div></li>
      <li class="co-header__item" [class.current]="mode() === 'step2'"><div>2</div><div>情報入力</div></li>
      <li class="co-header__item"><div>3</div><div>完了</div></li>
    </ol>
  </div>
</section>


@switch (mode()) {
  @case ('step1') {
    <app-step1 [bannerPc]="bannerPc()" [bannerSp]="bannerSp()" [lpType]="lpType()" [discount]="discount()" [isCasual]="isCasual()" [isColorful]="isColorful()"></app-step1>
  }
  @case ('step2') {
    @if (isSimple()) {
      @defer {
        <app-step2-simple [discount]="discount()" [isCasual]="isCasual()" [countries]="countries()" [cities]="cities()" [completeUrl]="complete()">
          <slot name="submit-button" slot="submit-button"></slot>
        </app-step2-simple>        
      }
    } @else {
      @defer {
        <app-step2></app-step2>
      }
    }
  }
}

